import React, { useCallback } from 'react';
import useToggle from '../hooks/useToggle.jsx';
import { Dropdown, Icon } from 'semantic-ui-react';

const ActionItemContext = React.createContext();

export default function ActionItem({
  icon,
  text,
  redirectOnClick,
  onClick,
  ...props
}) {
  const toggle = useToggle(false);
  const handleClick = useCallback(
    (e) => {
      if (props.disabled) {
        return;
      }

      toggle.setTrue();
      if (redirectOnClick) {
        Turbolinks.visit(redirectOnClick);
      } else if (onClick && e.currentTarget == e.target) {
        onClick(e);
      }
    },
    [redirectOnClick, props.disabled],
  );
  const handleClose = useCallback(() => {
    toggle.setFalse();
  }, []);

  return (
    <ActionItemContext.Provider
      value={{ clicked: toggle.value, onClose: handleClose }}
    >
      <Dropdown.Item
        {...props}
        style={{ pointerEvents: 'auto' }}
        onClick={handleClick}
      >
        {icon && <Icon name={icon} />}
        {text}
        {props.children}
      </Dropdown.Item>
    </ActionItemContext.Provider>
  );
}

ActionItem.Context = ActionItemContext;

ActionItem.defaultProps = {
  className: '',
  onClick: () => {},
};
